import { forwardRef } from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import { felixTokens } from "../../../../theme";
type Props = {
  onChange: (event: {
    target: {
      name: string;
      value: string;
      floatValue?: number;
      formattedValue: string;
    };
  }) => void;
  name: string;
};
const InteiroInput = forwardRef<NumericFormatProps, Props>(
  function InteiroInput(props, ref) {
    const { onChange, ...other } = props;

    // decimalScale antes do spread: quantidade internacional aceita fração
    // (1,6 cotas depois de um grupamento), o chamador passa a escala.
    return (
      <NumericFormat
        decimalScale={0}
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
              floatValue: values.floatValue,
              formattedValue: values.formattedValue,
            },
          });
        }}
        // Campo de quantidade: alinhado à direita e em mono tabular.
        style={{
          textAlign: "right",
          fontFamily: felixTokens.fontMono,
          fontVariantNumeric: "tabular-nums",
        }}
        thousandSeparator="."
        decimalSeparator=","
        valueIsNumericString
      />
    );
  }
);

export default InteiroInput;
